import React, {ReactElement} from 'react';

import Environment from '../utils/Environment';
import {getSearchParams} from '../utils/urlQuery';

function MaybeStagingBadge(): ReactElement | null {
  if (Environment.isProduction) return null;
  // QA escape hatch: hide the badge for clean screenshots via ?hideStagingBadge=1
  if (typeof window !== 'undefined' && getSearchParams().get('hideStagingBadge') === '1') {
    return null;
  }
  return (
    <div id="stagingBadge" className="badge bg-red-1 border-red-2 absolute mt-2 top-0 right-0">
      STAGING
    </div>
  );
}

export default MaybeStagingBadge;
